<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список клиентов</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактирование клиента</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="mb-4">
            <div class="form-label">Имя пользователя <span class="color-red">*</span></div>
            <input type="text" class="form-control" id="client-name" v-model="name" placeholder="Введите имя пользователя">
        </div>

        <div class="mb-4">
            <div class="form-label">Путь <span class="color-red">*</span></div>
            <input type="text" class="form-control" id="client-url" v-model="url" placeholder="ds-url">
        </div>

        <div class="mb-4">
            <div class="form-label">Комментарий</div>
            <textarea class="form-control mb-2" id="client-comment" rows="3" v-model="comment"></textarea>
        </div>
    </div>

    <div class="d-flex w-50 align-items-center justify-content-start">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="updateClient"/>
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import Client from "../../../../models/Client";
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "ClientEditComponent",
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_get: String,
        route_update: String,
        client_id: {
            type: [Number, String],
            default: 0
        }
    },
    data: function () {
       return {
           client: new Client({
               route_update: this.route_update,
               route_get: this.route_get
           }),
           name: '',
           comment: '',
           auto_create_license: '',
           url: '',
       }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        async updateClient () {
            console.log('ss');
            
            if (this.name == '') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите имя пользователя!' });
                this.toggleLoading();
                return;
            }
            if (this.url == '') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите путь!' });
                this.toggleLoading();
                return;
            }
            let result = await this.client.update({
                name: this.name,
                comment: this.comment,
                auto_create_license: this.auto_create_license,
                url: this.url
            }, this.client_id);

            if(result) {
                window.location.href = this.route_back;
            } else {
                console.log('error: create_brand');
                this.toggleLoading();
            }
        },
        itemGet: async function () {
            let item = await this.client.get(this.client_id);
            this.name = item.name;
            this.comment = item.comment;
            this.auto_create_license = item.auto_create_license;
            this.url = item.url;
        },
    },
    mounted() {
        this.itemGet();
    }
}
</script>

<style scoped>

</style>
